import React, { useState } from "react";
import styled from "styled-components";
import { AudioPlayer, H3, P, Checkbox, withDefaultMedia } from "../../";
import DipDrop from "../Dip Drop Stop Dip.mp3";
import { LearnMoreButton } from "./";
const SongContainer = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  z-index: 1;
  box-shadow: ${props => props.shadow ? "0 8px 8px 0 rgba(0,0,0,0.24), 0 0 8px 0 rgba(0,0,0,0.32)" : "none"};
  ${props => props.shadow && `
  z-index: 2;`}
`;
const SelectionContainer = styled.label`
  display: flex;
  align-items: center;
  flex-grow: 1;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  padding: 11px 24px 11px 0;
  @media only screen and ${props => props.theme.media.large} {
    padding: 11px 24px 11px 28px;
  }
`;
const SelectionHighlightEffect = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  border-bottom: 1px solid rgb(230, 233, 235);

  @media (hover: hover) {
    ${SelectionContainer}:hover & {
      background: rgb(245, 245, 245);
    }
  }

  ${props => props.isSelected && `
  background: ${props.theme.colors.actionLight};
  border-bottom: 1px solid ${props.theme.colors.action};
  `}
`;
export const Song = withDefaultMedia(({
  name,
  id,
  value,
  album,
  onChange,
  isSponsored,
  video,
  preview_url,
  highlight,
  matches
}) => {
  const isSelected = value.find(checkedId => checkedId === id);

  const handleChange = () => {
    isSelected ? onChange(value.filter(checkedId => checkedId !== id)) : onChange(value.concat([id]));
  };

  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = data => {
    setIsPlaying(data);
  };

  return /*#__PURE__*/React.createElement(SongContainer, {
    shadow: !!isPlaying,
    style: {
      paddingLeft: !preview_url && !matches.large && `24px`,
      paddingRight: !preview_url && matches.large && `24px`
    }
  }, /*#__PURE__*/React.createElement(SelectionContainer, null, /*#__PURE__*/React.createElement(Checkbox, {
    hideCheck: !matches.large,
    checked: isSelected,
    title: name,
    onChange: handleChange,
    "data-javelin-name": isSelected ? "remove-song" : "add-song",
    "data-javelin-meta": id
  }, album.name), /*#__PURE__*/React.createElement(SelectionHighlightEffect, {
    isSelected: isSelected
  })), /*#__PURE__*/React.createElement(LearnMoreButton, {
    highlight: highlight,
    video: video
  }), preview_url && /*#__PURE__*/React.createElement(AudioPlayer, {
    onPlay: handlePlay,
    src: preview_url
  }), !matches.large && /*#__PURE__*/React.createElement(CheckContainer, {
    onClick: handleChange
  }, isSelected ? /*#__PURE__*/React.createElement(Check, {
    width: "24",
    height: "21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.798.75L24 3.025 7.329 20.25 0 12.678l2.202-2.276L7.329 15.7z",
    "fill-rule": "nonzero"
  })) : /*#__PURE__*/React.createElement(Plus, {
    width: "16",
    height: "16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6h6v4h-6v6H6v-6H0V6h6V0h4v6z",
    "fill-rule": "evenodd"
  }))));
});
const CheckContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 24px;
  margin: 24px;
  cursor: pointer;
`;
const Plus = styled.svg`
  width: 16px;
  height: 16px;
  path {
    fill: ${props => props.theme.colors.inputText};
  }
`;
const Check = styled.svg`
  width: 24px;
  height: 21px;
  path {
    fill: ${props => props.theme.colors.action};
  }
`;